import React from 'react';
import '../../../../assests/css/admin/CustomerManagement/ActionMenu/ActionMenu.css';

const ActionMenu = ({ isOpen, onClose, customer, onAction, position }) => {
  if (!isOpen) return null;

  const status = customer?.customer?.status || customer?.status || 'Active';

  return (
    <div className="action-menu-overlay" onClick={onClose}>
      <div 
        className="action-menu" 
        style={{ top: position?.y || 100, left: position?.x || 100 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="action-item" onClick={() => onAction('view')}>
          <span className="action-icon">👁️</span>
          View Profile
        </button>
        <button className="action-item" onClick={() => onAction('orders')}>
          <span className="action-icon">📦</span>
          Order History
        </button>
        <button className="action-item" onClick={() => onAction('message')}>
          <span className="action-icon">✉️</span>
          Send Message
        </button>
        <button className="action-item action-suspend" onClick={() => onAction('suspend')}>
          <span className="action-icon">🚫</span>
          {status === 'Suspended' ? 'Activate Account' : 'Suspend Account'}
        </button>
        <button className="action-item action-delete" onClick={() => onAction('delete')}>
          <span className="action-icon">🗑️</span>
          Delete Customer
        </button>
      </div>
    </div>
  );
};

export default ActionMenu;